import { Injectable, NgZone } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { Address } from '../models/address.model';
import { BaryInseeService } from './bary-insee.service';

@Injectable({
  providedIn: 'root',
})
export class GooglePlacesService {
  constructor(private zone: NgZone, private baryInseeService: BaryInseeService) {}

  private getZipCodeFromDepartmentName(department: string): string | undefined {
    if (department === 'Ain') {
      return '01000';
    } else if (department === 'Aisne') {
      return '02000';
    } else if (department === 'Allier') {
      return '03000';
    } else if (department === 'Alpes-de-Haute-Provence') {
      return '04000';
    } else if (department === 'Hautes-Alpes') {
      return '05000';
    } else if (department === 'Alpes-Maritimes') {
      return '06000';
    } else if (department === 'Ardèche') {
      return '07000';
    } else if (department === 'Ardennes') {
      return '08000';
    } else if (department === 'Ariège') {
      return '09000';
    } else if (department === 'Aube') {
      return '10000';
    } else if (department === 'Aude') {
      return '11000';
    } else if (department === 'Aveyron') {
      return '12000';
    } else if (department === 'Bouches-du-Rhône') {
      return '13000';
    } else if (department === 'Calvados') {
      return '14000';
    } else if (department === 'Cantal') {
      return '15000';
    } else if (department === 'Charente') {
      return '16000';
    } else if (department === 'Charente-Maritime') {
      return '17000';
    } else if (department === 'Cher') {
      return '18000';
    } else if (department === 'Corrèze') {
      return '19000';
    } else if (department === 'Corse-du-Sud') {
      return '20000';
    } else if (department === 'Haute-Corse') {
      return '20000';
    } else if (department === "Côte-d'Or") {
      return '21000';
    } else if (department === "Côtes-d'Armor") {
      return '22000';
    } else if (department === 'Creuse') {
      return '23000';
    } else if (department === 'Dordogne') {
      return '24000';
    } else if (department === 'Doubs') {
      return '25000';
    } else if (department === 'Drôme') {
      return '26000';
    } else if (department === 'Eure') {
      return '27000';
    } else if (department === 'Eure-et-Loir') {
      return '28000';
    } else if (department === 'Finistère') {
      return '29000';
    } else if (department === 'Gard') {
      return '30000';
    } else if (department === 'Haute-Garonne') {
      return '31000';
    } else if (department === 'Gers') {
      return '32000';
    } else if (department === 'Gironde') {
      return '33000';
    } else if (department === 'Hérault') {
      return '34000';
    } else if (department === 'Ille-et-Vilaine') {
      return '35000';
    } else if (department === 'Indre') {
      return '36000';
    } else if (department === 'Indre-et-Loire') {
      return '37000';
    } else if (department === 'Isère') {
      return '38000';
    } else if (department === 'Jura') {
      return '39000';
    } else if (department === 'Landes') {
      return '40000';
    } else if (department === 'Loir-et-Cher') {
      return '41000';
    } else if (department === 'Loire') {
      return '42000';
    } else if (department === 'Haute-Loire') {
      return '43000';
    } else if (department === 'Loire-Atlantique') {
      return '44000';
    } else if (department === 'Loiret') {
      return '45000';
    } else if (department === 'Lot') {
      return '46000';
    } else if (department === 'Lot-et-Garonne') {
      return '47000';
    } else if (department === 'Lozère') {
      return '48000';
    } else if (department === 'Maine-et-Loire') {
      return '49000';
    } else if (department === 'Manche') {
      return '50000';
    } else if (department === 'Marne') {
      return '51000';
    } else if (department === 'Haute-Marne') {
      return '52000';
    } else if (department === 'Mayenne') {
      return '53000';
    } else if (department === 'Meurthe-et-Moselle') {
      return '54000';
    } else if (department === 'Meuse') {
      return '55000';
    } else if (department === 'Morbihan') {
      return '56000';
    } else if (department === 'Moselle') {
      return '57000';
    } else if (department === 'Nièvre') {
      return '58000';
    } else if (department === 'Nord') {
      return '59000';
    } else if (department === 'Oise') {
      return '60000';
    } else if (department === 'Orne') {
      return '61000';
    } else if (department === 'Pas-de-Calais') {
      return '62000';
    } else if (department === 'Puy-de-Dôme') {
      return '63000';
    } else if (department === 'Pyrénées-Atlantiques') {
      return '64000';
    } else if (department === 'Hautes-Pyrénées') {
      return '65000';
    } else if (department === 'Pyrénées-Orientales') {
      return '66000';
    } else if (department === 'Bas-Rhin') {
      return '67000';
    } else if (department === 'Haut-Rhin') {
      return '68000';
    } else if (department === 'Rhône') {
      return '69000';
    } else if (department === 'Haute-Saône') {
      return '70000';
    } else if (department === 'Saône-et-Loire') {
      return '71000';
    } else if (department === 'Sarthe') {
      return '72000';
    } else if (department === 'Savoie') {
      return '73000';
    } else if (department === 'Haute-Savoie') {
      return '74000';
    } else if (department === 'Arrondissement de Paris') {
      return '75000';
    } else if (department === 'Seine-Maritime') {
      return '76000';
    } else if (department === 'Seine-et-Marne') {
      return '77000';
    } else if (department === 'Yvelines') {
      return '78000';
    } else if (department === 'Deux-Sèvres') {
      return '79000';
    } else if (department === 'Somme') {
      return '80000';
    } else if (department === 'Tarn') {
      return '81000';
    } else if (department === 'Tarn-et-Garonne') {
      return '82000';
    } else if (department === 'Var') {
      return '83000';
    } else if (department === 'Vaucluse') {
      return '84000';
    } else if (department === 'Vendée') {
      return '85000';
    } else if (department === 'Vienne') {
      return '86000';
    } else if (department === 'Haute-Vienne') {
      return '87000';
    } else if (department === 'Vosges') {
      return '88000';
    } else if (department === 'Yonne') {
      return '89000';
    } else if (department === 'Territoire de Belfort') {
      return '90000';
    } else if (department === 'Essonne') {
      return '91000';
    } else if (department === 'Hauts-de-Seine') {
      return '92000';
    } else if (department === 'Seine-Saint-Denis') {
      return '93000';
    } else if (department === 'Val-de-Marne') {
      return '94000';
    } else if (department === "Val-d'Oise") {
      return '95000';
    }
    return undefined;
  }

  setAddress(addrObj: any): Observable<Address> {
    const address = new Address();
    this.zone.run(() => {
      if (addrObj['postal_code'] !== null && addrObj['postal_code'] !== undefined && addrObj['postal_code'] !== '') {
        address.zipCode = addrObj['postal_code'];
      } else if (addrObj['admin_area_l2'] !== null && addrObj['admin_area_l2'] !== undefined && addrObj['admin_area_l2'] !== '') {
        address.zipCode = this.getZipCodeFromDepartmentName(addrObj['admin_area_l2']);
      }

      address.zipCode = address.zipCode?.replace(' ', '');

      // Tentative d'obtenir le code postal par le nom du département
      if ((address.zipCode == null || address.zipCode === '') && addrObj['admin_area_l1'] !== null && addrObj['admin_area_l1'] !== undefined && addrObj['admin_area_l1'] !== '') {
        address.zipCode = this.getZipCodeFromAdminArea(addrObj['admin_area_l1']);
      }
      address.fullname = addrObj['fullname'];
      address.country = addrObj['countryCode'];
      address.city =
        addrObj['locality'] ??
        addrObj['postal_town'] ??
        addrObj['admin_area_l7'] ??
        addrObj['admin_area_l6'] ??
        addrObj['admin_area_l5'] ??
        addrObj['admin_area_l4'] ??
        addrObj['admin_area_l3'] ??
        addrObj['admin_area_l2'] ??
        addrObj['admin_area_l1'];
      address.streetNumber = addrObj['street_number'];
      address.street = addrObj['route'];
    });

    address.gps_coords = addrObj['lat'] + ',' + addrObj['lon'];

    if ('FR' === address.country) {
      // On récupère le code insee de la commune.
      return this.baryInseeService.getInseeCityCodeByGeoCoord(addrObj['lat'], addrObj['lon'], address.zipCode!, address.city!).pipe(
        map(commune => {
          address.cityCode = commune?.code;
          return address;
        })
      );
    } else {
      return of(address);
    }
  }

  getZipCodeFromAdminArea(adminArea: string): string | undefined {
    switch (adminArea) {
      case "Provence-Alpes-Côte d'Azur":
        return '13000';
      case 'IDF':
        return '75000';
      case 'Gironde':
        return '33000';
      default:
        return undefined;
    }
  }
}
